import { Collapse, List, ListItem, ListItemIcon, ListItemText, makeStyles } from '@material-ui/core'
import React, { useState } from 'react'
import FolderIcon from '@material-ui/icons/Folder';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';

const useStyles = makeStyles((theme) => ({
    nested: {
      paddingLeft: theme.spacing(4),
      display:"block"
    },
    link:{
        textDecoration:"none",
        color:'rgba(0, 0, 0, 0.87)'
    }
  }));

const ItemFormulario = ({ text, items }) => {
    const classes=useStyles()
    const [open, setOpen] = useState(false)

    const handleClick = () => {
        setOpen(!open);
    }
    return (
        <>
            <ListItem button onClick={handleClick}>
                <ListItemIcon>
                    <FolderIcon color="primary" />
                </ListItemIcon>
                <ListItemText primary={text} />
                {open ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={open} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                    <ListItem button className={classes.nested}>
                        {
                            items.map(e=>{
                                return(
                                    <div key={e.label} style={{marginBottom:"1rem"}}><a  href={e.link} target="_blank" rel="noreferrer" className={classes.link}><ListItemText primary={e.label} /></a></div>

                                )
                            })
                        }
                    </ListItem>
                </List>
            </Collapse>
        </>
    )
}

export default ItemFormulario
